import gql from 'graphql-tag'

export const replaceCartProducts = gql`
    mutation replaceMyCartProducts($products: [CartProductDataInput!]!) {
        replaceMyCartProducts(products: $products) {
            id
            cart_products {
                product { id }
                piece
            }
        }
    }
`
